import React, { useState } from 'react';
import { useCurrentProjectIdContext, useTranslationContext } from "./project-builder-main.jsx";
import { useQuery } from '@tanstack/react-query';
import { getProject } from '../../../apis/project-builder';
import DeleteModal from './delete-modal.jsx';
import Checkbox from '@mui/material/Checkbox';
import AddedAttachmentsCard from './added-attachments-card.jsx';
//import Loader from '../../../../shared/react/components/loader.jsx';


export default function AddedAttachmentsList({ isSelectable, openSearchModal, selectedAttachmentIds, setSelectedAttachmentIds }) {

    const [showVideos, setShowVideos] = useState(false);
    const { currentProjectId } = useCurrentProjectIdContext();
    const {translations} = useTranslationContext();

    const { data, isSuccess, isLoading, isError, error } = useQuery(['project-detail', currentProjectId], () => getProject(currentProjectId));


    return (
        <>
            {isSuccess
                ? <div className="project-section added-attachments">
                    <div className="section-title">{translations.Attachments}</div>
                    <div className="section-subtitle">{translations.Documents}</div>
                    <div className="row">
                        {data.attachements?.filter(attachment => attachment.isDocument).map((attachment) => (
                            <AddedAttachmentsCard
                                isSelectable={isSelectable}
                                attachment={attachment}
                                selectedAttachmentIds={selectedAttachmentIds}
                                setSelectedAttachmentIds={setSelectedAttachmentIds}
                            />
                        ))}

                        <div className="col-md-6 mb-2">
                            <div className="attachment-card attachment-card--add rounded-border" onClick={openSearchModal}>
                                <button className="btn-add btn-add--small" type="button"><span className="plus-icon plus-icon--small">+</span></button>
                                <div className="cta-title">{translations.SearchDocuments}</div>
                            </div>
                        </div>
                    </div>
                    {showVideos && (
                        <>
                            <div className="section-subtitle">{translations.Videos}</div>
                            <div className="row">
                                {data.attachments?.filter(attachment => attachment.isVideo).map((attachment) => (
                                    <AddedAttachmentsCard
                                        isSelectable={isSelectable}
                                        attachment={attachment}
                                        selectedAttachmentIds={selectedAttachmentIds}
                                        setSelectedAttachmentIds={setSelectedAttachmentIds}
                                    />
                                ))}

                                <div className="col-md-6 mb-2">
                                    <div className="attachment-card attachment-card--add rounded-border" onClick={openSearchModal}>
                                        <button className="btn-add btn-add--small" type="button"><span className="plus-icon plus-icon--small">+</span></button>
                                        <div className="cta-title">{translations.SearchVideos}</div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                </div>
                : null
            }
        </>
    );
}